/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function(e) {
  let buttons = document.getElementsByClassName("quantity-button");
  for (let button of buttons) {
    button.addEventListener('click', function(e) {
      if (e.target.dataset.action == 'increase') {
        let inputTarget = document.getElementById(e.target.dataset.inputId);
        console.log(e.target.dataset.maxQuantity);
        if (parseInt(inputTarget.value) >= parseInt(e.target.dataset.maxQuantity)) {
          inputTarget.value = e.target.dataset.maxQuantity;
          return;
        }
        inputTarget.value = parseInt(inputTarget.value) + 1;
      } else if (e.target.dataset.action == 'decrease') {
        let inputTarget = document.getElementById(e.target.dataset.inputId);
        if (parseInt(inputTarget.value) <= 0) { // can't be less than 0 
          inputTarget.value = 0;
          return;
        }
        inputTarget.value = parseInt(inputTarget.value) - 1;
      }
    });
  }
  let inputs = document.getElementsByClassName("quantity-input");
  for (let quantity_input of inputs) {
    quantity_input.addEventListener('change', function(e) {
      if (parseInt(e.target.value) >= e.target.dataset.maxQuantity) {
        e.target.value = e.target.dataset.maxQuantity;
        return;
      } else if (parseInt(e.target.value) <= 0) {
        e.target.value = 0;
        return;
      }
    });
  }
});